import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityService } from "../services/entity-service";
import { AdminService } from "../services/admin-service";
import { RLMigrateEntityController } from "./migrate-entity";

export function RLCharTypeTemplateAssociationsTreeView() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/chartype-template-associations-tree-view.html"),
        controller: RLCharTypeTemplateAssociationsTreeViewController,
        controllerAs: "cttvVM",
        require: ["rlCharTypeTemplateAssociationsTreeView", "^rlMigrateEntity"],
        bindToController: true,
        scope: {
            filterByEntityID: "=filterByEntityId",
            charTypesAndTemplateGroups: "=",
            searchStates: "=",
            totalCharCounts: "=",
            totalSearchToCount: "=",
            searching: "="
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLCharTypeTemplateAssociationsTreeViewController, RLMigrateEntityController]) => {
            controllers[0].migrateCtrl = controllers[1];
        }
    };

    return directive;
}

export class RLCharTypeTemplateAssociationsTreeViewController {
    static $inject = ["$scope", "$location", "$filter", "notifyService", "$window", "$q", "eventService", "entityService", "adminService", "$interval"];
    loading: boolean;

    filterByEntityID: string;
    charTypesAndTemplateGroups: Models.IAssociationCharTypeTemplates[];
    searchStates: { [key: string]: Models.IAdvancedSearchModel };

    groupCollapsed: { [charTypeID: number]: boolean };
    subGroupCollapsed: { [comboID: string]: boolean };
    itemCounts: { [key: string]: number };
    totalCharCounts: { [key: number]: number };
    showAssociationResults: { [comboID: string]: boolean };

    allChecked: boolean;
    allCollapsed: boolean;
    isCollapsed: boolean;

    selectedChars: { [charTypeID: number]: boolean };
    partialChars: { [charTypeID: number]: boolean };
    selectedTemplates: { [comboID: string]: boolean };
    selectedTemplatesForAssociations: { [comboID: string]: boolean };

    migrateCtrl: RLMigrateEntityController;
    counter: number = 0;
    totalSearchToCount: number;
    searching: boolean;

    constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private $filter: ng.IFilterService,
        public notifyService: NotifyService, private $window: ng.IWindowService,
        public $q: ng.IQService,
        private eventService: EventService,
        private entityService: EntityService,
        public adminService: AdminService,
        public $interval: ng.IIntervalService) {

        this.loading = true;

        this.groupCollapsed = {};
        this.subGroupCollapsed = {};
        this.showAssociationResults = {};

        this.isCollapsed = true;

        this.selectedChars = {};
        this.partialChars = {};
        this.selectedTemplates = {};
        this.selectedTemplatesForAssociations = {}

        this.$scope.$watch(() => this.itemCounts, (newValue: { [key: string]: number }, oldValue: { [key: string]: number }) => {
            if (_.keys(newValue).length > 0) {
                this.UpdateCharTypeCounts();
                this.UpdateSearchingStatus();
            }

            if (this.allChecked) {
                this.ToggleCharsSelected();
            }

            if (this.allCollapsed) {
                this.CollapseAll(true);
            }
        }, true);

        this.$scope.$watch(() => this.searchStates, (newValue: { [key: string]: Models.IAdvancedSearchModel }, oldValue: { [key: string]: Models.IAdvancedSearchModel }) => {
            if (_.keys(newValue).length > 0) {
                this.UpdateCharTypeCounts();
            }

            if (this.allChecked) {
                this.ToggleCharsSelected();
            }

            if (this.allCollapsed) {
                this.CollapseAll(true);
            }


        }, true);

        this.$scope.$watch(() => this.migrateCtrl.selectedItems, (newValue, oldValue) => {
            if (this.migrateCtrl.selectedItems != null && this.migrateCtrl.selectedItems.length > 0) {

                _.forEach(this.migrateCtrl.selectedItems, si => {
                    var charID = si.charTypeID;
                    var templateID = si.templateID;

                    //Check chars
                    var itemsCharCount = _.filter(this.migrateCtrl.selectedItems, i => i.charTypeID == charID).length;
                    var selectedItemsCharCount = _.filter(this.migrateCtrl.selectedItems, i => i.charTypeID == charID && i.selected).length;

                    if (selectedItemsCharCount != itemsCharCount) {
                        this.selectedChars[charID] = false;
                    }
                    else {
                        this.selectedChars[charID] = true;
                    }

                    //Check template
                    var totalItemsPerTemplateCount = _.filter(this.migrateCtrl.selectedItems, i => i.charTypeID == charID && i.templateID == templateID).length;
                    var selectedItemsTemplateCount = _.filter(this.migrateCtrl.selectedItems, i => i.charTypeID == charID && i.templateID == templateID && i.selected).length;

                    if (selectedItemsTemplateCount != totalItemsPerTemplateCount) {
                        delete this.selectedTemplatesForAssociations[charID.toString() + "|" + templateID.toString()];
                        this.selectedTemplates[charID.toString() + "|" + templateID.toString()] = false;
                    }
                    else {
                        this.selectedTemplates[charID.toString() + "|" + templateID.toString()] = true;
                    }
                });
            }
        }, true);
    }

    Initialize() {
        this.allChecked = true;
        this.allCollapsed = true;
    }

    UpdateCharTypeCounts() {
        this.totalCharCounts = [];

        for (var countKey in this.searchStates) {
            var ic: string = countKey;
            var charAndTempSplit = ic.split("|");
            var charID = charAndTempSplit[0];

            var currentCharCount = this.totalCharCounts[charID];

            if (currentCharCount == null) {
                currentCharCount = 0;
            }

            var count = 0;
            if (this.itemCounts != null && this.itemCounts[countKey] != null && this.showAssociationResults[countKey]) {
                count = this.itemCounts[countKey];
            }

            var newCharCount = currentCharCount + count;
            this.totalCharCounts[charID] = newCharCount;
        }
    }

    UpdateSearchingStatus() {
        this.counter++;
        
        if (this.counter == this.totalSearchToCount) {
            this.searching = false;
        }
    }

    IsParentChar(charTypeID: number) {
        var charType = _.find(this.charTypesAndTemplateGroups, c => c.id == charTypeID);

        return charType.isParentChar;
    }

    ToggleOpen(charTypeID: number, allCollapsed?: boolean) {
        if (allCollapsed) {
            this.groupCollapsed[charTypeID] = true;
        }
        else {
            this.groupCollapsed[charTypeID] = !this.groupCollapsed[charTypeID];
            this.allCollapsed = false;
        }
    }

    ToggleTemplateOpen(charTypeID: number, templateID: number, allCollapsed?: boolean) {
        if (allCollapsed) {
            var combo = charTypeID.toString() + '|' + templateID.toString();
            this.subGroupCollapsed[combo] = true;
        }
        else {
            var combo = charTypeID.toString() + '|' + templateID.toString();
            this.subGroupCollapsed[combo] = !this.subGroupCollapsed[combo];
            this.allCollapsed = false;
        }
    }

    CollapseToggle() {
        this.isCollapsed = !this.isCollapsed;

        if (this.isCollapsed) {
            _.forEach(this.charTypesAndTemplateGroups, (char) => {
                this.ToggleOpen(char.id, true);

                _.forEach(char.children, (template) => {
                    this.ToggleTemplateOpen(char.id, template.id);
                });
            });

            this.loading = false;
        }
        else {
            this.groupCollapsed = {};
            this.subGroupCollapsed = {};
        }
    }

    CollapseAll(allCollapsed?: boolean) {
        this.isCollapsed = true;

        _.forEach(this.charTypesAndTemplateGroups, (char) => {
            this.ToggleOpen(char.id, allCollapsed);

            _.forEach(char.children, (template) => {
                this.ToggleTemplateOpen(char.id, template.id);
            });
        });

        this.loading = false;
    }

    ToggleCharsSelected() {
        _.forEach(this.charTypesAndTemplateGroups, (char) => {
            if (this.totalCharCounts[char.id] > 0) {
                this.selectedChars[char.id] = this.allChecked;
                this.ToggleTemplateSelected(char, this.allChecked);
            }
        });
    }

    //This is a charType level select, all content below will be selected
    ToggleTemplateSelected(char: Models.IAssociationCharTypeTemplates, selected?: boolean) {

        var tempSelectedTemplates = _.clone(this.selectedTemplatesForAssociations);

        _.forEach(char.children, (template) => {
            if (this.showAssociationResults[char.id.toString() + '|' + template.id.toString()]) {
                if (selected != null) {
                    tempSelectedTemplates[char.id.toString() + "|" + template.id.toString()] = selected;
                }
                else {
                    tempSelectedTemplates[char.id.toString() + "|" + template.id.toString()] = this.selectedChars[char.id];
                    this.selectedTemplates[char.id.toString() + "|" + template.id.toString()] = this.selectedChars[char.id];
                }

                this.selectedTemplatesForAssociations = tempSelectedTemplates;
            }
        });
    }

    //This is a template level select, all associations below will be selected for the parent char only
    ToggleAssociationsSelected(charTypeID: number, templateID: number) {
        //If there are no more templates of this charType selected, then set the parent charType to false

        //This originally included the use of partial selects - which we are leaving out for now as it is not quite working visually.

        var modifiedTemplate = charTypeID.toString() + "|" + templateID.toString();

        if (!this.selectedTemplates[modifiedTemplate]) {
            this.selectedChars[charTypeID] = false;
        }
        else {
            //Check to see if any other templates in the char type are selected, if all others are selected, then set the char to true
            var charTypeValue = true;
            for (var comboID in this.selectedTemplates) {
                var id: string = comboID;
                if (id.indexOf(charTypeID + "|") == 0) {
                    if (!this.selectedTemplates[id]) {
                        charTypeValue = false;
                        this.allChecked = false;
                        break;
                    }
                }
            }

            this.selectedChars[charTypeID] = charTypeValue;

            if (!charTypeValue) {
                this.allChecked = false;
            }
        }

        if (this.selectedTemplatesForAssociations[modifiedTemplate] == null) {
            //This means the user hand-toggled some rows.  We removed it to avoid future "select all" functionality
            //We do, however want to add it back in now with the appropriate setting

            var selectAllForTemplate = this.selectedTemplates[modifiedTemplate];

            this.selectedTemplatesForAssociations[modifiedTemplate] = selectAllForTemplate == null ? false : selectAllForTemplate;
        }
        else {
            this.selectedTemplatesForAssociations[modifiedTemplate] = !this.selectedTemplatesForAssociations[modifiedTemplate];
        }
    }
}
